import { render, staticRenderFns } from "./TagDetailStats.vue?vue&type=template&id=30f5b594&scoped=true"
import script from "./TagDetailStats.vue?vue&type=script&lang=js"
export * from "./TagDetailStats.vue?vue&type=script&lang=js"
import style0 from "./TagDetailStats.vue?vue&type=style&index=0&id=30f5b594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5b594",
  null
  
)

export default component.exports